import { latestTicker, quickEntries } from '@/mocks/home';

export default function TopStrip() {
  const tickerItems = [...latestTicker, ...latestTicker];

  return (
    <div className="bg-foreground-950 text-background-100">
      <div className="flex h-9 items-center gap-4 px-4 md:px-6 font-label text-xs">
        <span className="hidden shrink-0 items-center gap-2 sm:flex">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-primary-500 opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
          </span>
          <span className="tracking-[0.2em] text-primary-300">实时更新</span>
        </span>

        <span className="hidden h-4 w-px shrink-0 bg-foreground-700 sm:block" />

        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee whitespace-nowrap">
            {tickerItems.map((item, index) => (
              <span key={`${item}-${index}`} className="mx-6 text-background-200">
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className="hidden shrink-0 items-center gap-4 lg:flex">
          {quickEntries.map((entry) => (
            <a
              key={entry.label}
              href={entry.href}
              className="flex items-center gap-1.5 text-background-300 transition-colors hover:text-accent-400"
            >
              <i className={entry.icon} />
              <span>{entry.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}